import { Order as AtSetupOrder } from '../ng-services/atsetup.type';
import { TradeSetupOrderDirection, TradeSetupOrderType } from '../ng-services/atsetup-enum.type';

class Order {
    constructor(protected order: AtSetupOrder) {}

    get isSellOrder() {
        return this.order.action === TradeSetupOrderDirection.Sell;
    }

    get isBuyOrder() {
        return !this.isSellOrder;
    }

    get price() {
        // based on conversation with Vitali:
        // use price for limit order and stopPrice for stop order

        if ([TradeSetupOrderType.Stop].includes(this.order.type)) {
            return this.order.stopPrice.Price;
        }

        return this.order.price.Price;
    }

    get quantity() {
        return this.order.quantity;
    }

    get actionLabel() {
        return this.isSellOrder ? 'Sell' : 'Buy';
    }

    get typeLabel() {
        switch (this.order.type) {
            case TradeSetupOrderType.Stop:
                return 'Stop';
            case TradeSetupOrderType.Limit:
                return 'Limit';
            case TradeSetupOrderType.StopLimit:
                return 'Stop Limit';
            case TradeSetupOrderType.Market:
                return 'Market';
        }
        return '';
    }

    get orderName() {
        return this.order.orderName;
    }

    get label() {
        return `${this.actionLabel} ${this.typeLabel} Order ${this.quantity}@${this.price} '${this.orderName}'`;
    }
}

export function parseTradeSetupOrders(orders: AtSetupOrder[]) {
    return orders.map((order) => new Order(order));
}
